<template>
    <div class="cards-main__slider swiper">
        <div class="cards-main__wrapper swiper-wrapper" id="complexes-container">
            <div class="loader-container" v-if="isLoading">
                <loader-gray></loader-gray>
            </div>
            <div class="cards-main__slide swiper-slide"
                 v-for="complex in complexes"
                 :key="complex.id"
            >
                <catalog-complex-card
                    :complex="complex"
                    :is-slider="true"
                ></catalog-complex-card>
            </div>
        </div>
        <div class="cards-main__pagination swiper-pagination"></div>
    </div>
</template>

<script>
import Swiper, {EffectFade, Navigation, Pagination} from 'swiper';
import LoaderGray from "../loaders/LoaderGray.vue";

export default {
    name: "ComplexSliderLazy",
    components: {LoaderGray},
    props: {
        complexes: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiper: null,
            nextPage: 2,
            isLoading: false,
            cacheKey: 'complexes_cache',
            cacheExpiration: 3600000
        }
    },
    mounted() {
        this.initLazySwiperCards();
        this.$nextTick(() => {
            this.initSwiperImages();
        })
        this.loadComplexesFromCache();
    },
    methods: {
        initLazySwiperCards() {
            this.isLoading = true
            let arrsPrev = document.querySelectorAll(".cards-main-button_prev");
            let arrsNext = document.querySelectorAll(".cards-main-button_next");
            let cardMainSlider = document.querySelectorAll(".cards-main__slider");
            for (let index = 0; index < cardMainSlider.length; index++) {
                const slider = cardMainSlider[index];
                this.swiper = new Swiper(slider, {
                    modules: [Pagination, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    navigation: {
                        prevEl: arrsPrev[index],
                        nextEl: arrsNext[index]
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        }
                    },
                    on: {
                        reachEnd: this.loadMoreComplexes
                    }
                });
            }
            this.isLoading = false
        },
        initSwiperImages() {
            let arrsPrev = document.querySelectorAll(".card-button_prev");
            let arrsNext = document.querySelectorAll(".card-button_next");
            let cardSlider = document.querySelectorAll(".card__slider");

            for (let index = 0; index < cardSlider.length; index++) {
                const slider = cardSlider[index];
                new Swiper(slider, {
                    modules: [Pagination, EffectFade, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        prevEl: arrsPrev[index],
                        nextEl: arrsNext[index]
                    },
                    on: {
                        touchStart: (e) => {
                            if (this.swiper) {
                                this.swiper.allowTouchMove = false;
                            }
                        },
                        touchEnd: (e) => {
                            if (this.swiper) {
                                this.swiper.allowTouchMove = true;
                            }
                        }
                    }
                });
            }
        },
        loadComplexesFromCache() {
            const cachedData = JSON.parse(localStorage.getItem(this.cacheKey));
            if (cachedData) {
                const isCacheExpired = Date.now() - cachedData.timestamp > this.cacheExpiration;
                if (!isCacheExpired) {
                    this.complexes = cachedData.complexes.slice(0, 12);
                    this.nextPage = cachedData.nextPage;
                    this.$nextTick(() => {
                        this.swiper.update();
                    });
                    return;
                } else {
                    this.clearCache();
                }
            }
        },
        async loadMoreComplexes() {
            if (this.nextPage < 4) {
                try {
                    const response = await fetch(`${this.$root.baseUrl}/complexes/lazy-load?page=${this.nextPage}`);
                    const data = await response.json();
                    this.complexes = this.complexes.concat(data.complexes);
                    this.$nextTick(() => {
                        this.swiper.update();
                    });
                    this.nextPage = data.next_page;
                    this.saveToCache();
                } catch (error) {
                    console.error('Error loading more complexes:', error);
                    this.clearCache();
                }
            }
        },
        saveToCache() {
            const cacheData = {
                complexes: this.complexes,
                nextPage: this.nextPage,
                timestamp: Date.now()
            };
            localStorage.setItem(this.cacheKey, JSON.stringify(cacheData));
        },
        clearCache() {
            localStorage.removeItem(this.cacheKey);
        }
    }
}
</script>
